module.exports = "/_next/static/images/Insta-1cabcfc3035fcd23745b6b90bb32b24c.svg";